import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import DigitalParametersMixin from '@/common/mixins/digitalHelper';

/* ----- mixin for controlling the Integration flow(like Header Enrichment configuration) ------

 If an integration is configured:
 - when user presses register button, the below actions/steps are executed (in order):
 registrationRedirect()
 -> getPreRedirectionAction()  [execute appropriate actions (of active integration) before redirect user]
 -> integrationRedirect() (or register1) [get the partner url from backend, if no url go to register1]
 -> redirection to partner (or register2)  [user is redirected to partner url or to register2 page]

 - when partner redirect user (with their response) to visitor (or other) page, the below step is executed:
 getIntegrationParametersCheck()

 - when user un-sub from Duel, the below action is executed (for now, only on Vodacom needed):
 getPostUnSubAction()

 So, when a new integration need to be added, its logic need to be implemented on methods:
 getPreRedirectionAction(), getIntegrationParametersCheck(), getPostUnSubAction() [if needed]
 and use them appropriately from different components (visitor, index, signup etc)
 */

const IntegrationMixin = {
  mixins: [DigitalParametersMixin],
  data() {
    return {
      showLoadingModal: false,
      HE_ERROR_CODE: false,
      HE_LOGIN_INFO: false,
      SHOW_OPERATOR_CHOICE: false,
      ERROR_REDIRECT_MESSAGE: '',
      SHOW_HE_ERROR_RESPONSE_CODE_MESSAGE: false,
      errorStatusCode: '',
      REGISTRATION_ENDPOINT: 'api/getRegisterUrl',
    };
  },
  methods: {
    ...mapActions('common', [
      'getDecodedStatus',
      'getUserExistsInCore',
      'getUserIsRegistered',
      'updateIntegrationInfo',
      'reOptinProcess',
      'storeOperator',
      'sendAvatarCall',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
      'updateRefUrl',
      'updateCampaignId',
      'updatePublisherId',
      'storeClickid',
      'setShowSelectOperatorModal',
      'facebookReferral',
      'setOneTimeSubscriptionBundleId',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
      'setFirstTimeEntry',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'storeLoginInfo',
      'updateGovernorate',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    registrationRedirect() {
      this.getPreRedirectionAction()();
    },
    getPreRedirectionAction() {
      switch (this.integrationHeader) {
        case this.availableIntegrations.ASIACELL_IRAQ.name:
          return () => {
            window.location.href = `${window.location.origin}/api/getRegisterUrl?refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}&lang=${this.getLocale || ''}&msisdn=${this.$route.query.msisdn}`;
          };
        default:
          return () => {
            this.$router.push('register1');
          };
      }
    },
    integrationRedirect() {
      const activeIntegration = this.getIntegrationByName();
      let url = this.REGISTRATION_ENDPOINT;
      const numOfParameters = activeIntegration.value.info.length;
      if (numOfParameters) url = `${url}?`;
      activeIntegration.value.info.forEach((element, index) => {
        url = `${url}${element.key}=${element.value}`;
        if (index + 1 !== numOfParameters) url = `${url}&`;
      });
      this.storeParametersToBrowserStorage();
      if (activeIntegration.value.storeDigitalParams) {
        url = `${url}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}&friendRef=${this.fbReferral || ''}`;
      }
      this.$axios.get(url).then((response) => {
        const responseEnum = response.data.responseEnum;
        let redirectionUrl = response.data.data;
        if (responseEnum === 'OPERATION_SUCCESS') {
          this.toggleSelectOperatorModal(false);
          if (redirectionUrl && redirectionUrl.startsWith('http')) {
            if (activeIntegration.value.transferDigitalParams) {
              redirectionUrl = `${redirectionUrl}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
            }
            window.location.href = redirectionUrl;
          } else {
            sessionStorage.setItem('msisdn', redirectionUrl);
            this.$router.push('register2');
          }
        } else {
          this.ERROR_REDIRECT_MESSAGE = responseEnum;
        }
      });
    },
    getIntegrationParametersCheck() {
      switch (this.integrationHeader) {
        default:
          return (to) => {
            this.proceedToAutoLogin(to);
            // eslint-disable-next-line
            console.log(`No parameter check ( parameters: ${to.query}) for active integration: ${this.integrationHeader}`);
          };
      }
    },
    proceedToAutoLogin(to) {
      // eslint-disable-next-line
      console.log('No parameter check ( parameters: ' + to.query.user_auth_token + ') for active integration: ' + to.query.username);
      if (to.query.user_auth_token && to.query.username) {
        this.storeLoginInfo({
          token: to.query.user_auth_token,
          rememberMeParameter: true,
          username: to.query.username,
        });
        this.getUserLoginDetails().then(() => {
          this.updateUserLanguage();
          this.$router.push('home');
        });
      }
    },
    getAlternateRequestPinAction() {
      switch (this.integrationHeader) {
        case this.availableIntegrations.SYRIATEL_SYRIA.name:
          return (msisdn, operator) => {
            const userMsisdn = msisdn || this.user.msisdn;
            const userOperator = operator || this.operatorPicked;
            this.$axios.get(`api/requestPinInApp?msisdn=${userMsisdn}&operator=${userOperator}&lang=${this.getLocale}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&digital=true`).then((resp) => {
              if (resp.data.responseEnum === 'OPERATION_SUCCESS') {
                sessionStorage.setItem('msisdn', userMsisdn);
                sessionStorage.setItem('operator', userOperator);
                this.toggleSelectOperatorModal(false);
                this.$router.push('/register2');
              } else if (resp.data.responseEnum === 'ALREADY_REGISTERED') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
              } else if (resp.data.responseEnum === 'MSISDN_INVALID') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
              } else {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
              }
              this.mapErrorMessages(resp.data.responseEnum);
            });
          };
        case this.availableIntegrations.ASIACELL_IRAQ.name:
          return ({ msisdn, operator } = {}) => () => {
            const userMsisdn = msisdn || this.user.msisdn;
            const userOperator = operator || this.operatorPicked;
            this.$axios.get(`api/requestPinInApp?msisdn=${userMsisdn}&operator=${userOperator}&lang=${this.getLocale}`).then((res) => {
              let response = res.data.responseEnum;
              if (response == null) {
                response = res.data.data;
              } else if (response === 'OPERATION_SUCCESS') {
                this.toggleSelectOperatorModal(false);
                sessionStorage.setItem('msisdn', userMsisdn);
                this.$router.push('/register2');
              } else if (response === 'ALREADY_REGISTERED' || response === 'ALREADY_SUB_USER') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
              } else if (response === 'MSISDN_INVALID') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
              } else {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
              }
              this.mapErrorMessages(response);
            });
          };
        default:
          return () => null;
      }
    },
    getAlternateVerifyPinAction() {
      switch (this.integrationHeader) {
        case this.availableIntegrations.SYRIATEL_SYRIA.name:
          return () => {
            this.$axios.get(`api/verifyPinInApp?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}`).then((response) => {
              const resp = response.data.responseEnum;
              this.waitForResponse = false;
              this.showLoadingModal = true;
              if (resp === 'OPERATION_SUCCESS') {
                this.$axios.get(`api/getStatus?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}`).then((res) => {
                  this.showLoadingModal = false;
                  if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                    const hasSub = res.data.data.isSub;
                    if (hasSub === 'true') {
                      this.sendCompleteRegistrationEvent();
                    }
                    this.storeLoginInfo({
                      token: res.data.data.user_auth_token,
                      rememberMeParameter: false,
                      username: res.data.data.username,
                    });
                    this.getUserLoginDetails().then(() => {
                      this.updateUserLanguage();
                      this.$router.push('home');
                    });
                  } else {
                    this.$router.push('/');
                  }
                });
              } else {
                if (resp === 'PIN_EXPIRED') {
                  this.message = 'visitor_sign_up_2_pin_expired';
                } else if (resp === 'WRONG_PIN' || resp === 'IncorrectPincode') {
                  this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
                } else if (resp === 'BLOCKED_USER') {
                  this.message = 'visitor_forgot_password_warning_msd_max_attempts';
                } else if (resp === 'SERVER_ERROR') {
                  this.message = 'home_profile_profile_edit_server_unvailable';
                } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
                  this.message = 'visitor_sign_up_warning_third_party_error';
                } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
                  this.message = 'registration_process_with_test_msisdn_perfomed';
                } else if (resp === 'REQUEST_IGNORED') {
                  this.message = 'visitor_sign_up_2_not_valid_transaction';
                }
                this.showLoadingModal = false;
                this.hasErrors = true;
              }
            });
          };
        case this.availableIntegrations.ASIACELL_IRAQ.name:
          return ({ userInfo } = {}) => {
            this.$axios.get(`api/verifyPinInApp?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&webflow=true`).then((res) => {
              let resp = res.data.responseEnum;
              if (resp == null) {
                resp = res.data.data;
              }
              this.waitForResponse = false;
              this.showLoadingModal = true;
              if (resp === 'OPERATION_SUCCESS') {
                this.$axios.get(`api/getStatus?msisdn=${sessionStorage.getItem('msisdn')}&pin=${this.user.pin}&lang=${this.getLocale}`).then((response) => {
                  this.showLoadingModal = false;
                  if (response.data.responseEnum === 'OPERATION_SUCCESS' && response.data.data) {
                    const hasSub = response.data.data.isSub;
                    if (hasSub === 'true') {
                      this.sendCompleteRegistrationEvent();
                    }
                    this.storeLoginInfo({
                      token: response.data.data.user_auth_token,
                      rememberMeParameter: userInfo.rememberMe,
                      username: res.data.data.username,
                    });
                    this.getUserLoginDetails().then(() => {
                      this.updateUserLanguage().then(() => {
                        this.sendAvatarCall().then(() => {
                          this.updateGovernorate({ governorate: userInfo.governorate }).then(() => {
                            this.$router.push('home');
                          });
                        });
                      });
                    });
                  } else {
                    this.$router.push('/');
                  }
                });
              } else if (resp === 'ALREADY_REGISTERED') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'ALREADY_REGISTERED';
              } else if (resp === 'MSISDN_INVALID') {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
              } else {
                this.errors = true;
                this.ERROR_REDIRECT_MESSAGE = 'SERVER_ERROR';
              }
              this.mapErrorMessages(resp);
            });
          };
        default:
          return null;
      }
    },
    // ----------- reSub/unSub methods ----------------------------------
    alternateReSubAction() {
      switch (this.integrationHeader) {
        case this.availableIntegrations.SYRIATEL_SYRIA.name:
          return (msisdn) => {
            this.$axios.get(`api/requestPinInApp?msisdn=${msisdn}&reoptin=true&lang=${this.getLocale}`).then((response) => {
              // eslint-disable-next-line
              this.reSubCallback(response);
            });
          };
        case this.availableIntegrations.ASIACELL_IRAQ.name:
          return (msisdn) => {
            this.$axios.get(`api/requestPinInApp?msisdn=${msisdn}&reoptin=true&lang=${this.getLocale}`).then((response) => {
              this.reSubCallback(response);
            });
          };
        default:
          return () => {
            // eslint-disable-next-line
            console.log(`No presub action check for active integration: ${this.integrationHeader}`);
          };
      }
    },
    standardReSubAction() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      return this.reOptinProcess();
    },
    getAppropriateReSubAction() {
      const activeIntegration = this.getIntegrationByName();
      if (activeIntegration && (activeIntegration.value.name === this.availableIntegrations.ASIACELL_IRAQ.name)) {
        this.alternateReSubAction()(this.userDetails.msisdn, this.userDetails.operatorName);
      } else if (activeIntegration.value.name === this.availableIntegrations.SYRIATEL_SYRIA.name) {
        this.alternateReSubAction()(this.userDetails.msisdn, this.userDetails.operatorName);
      } else {
        this.standardReSubAction().then((response) => {
          this.reSubCallback(response);
        });
      }
    },
    getPostReSubAction() {
      switch (this.integrationHeader) {
        default:
          return () => {
            // eslint-disable-next-line
            console.log(`No action needed for active integration: ${this.integrationHeader}`);
          };
      }
    },
    getReSubParametersCheck() {
      switch (this.integrationHeader) {
        default:
          return (to) => {
            // eslint-disable-next-line
            console.log(`No parameter check ( parameters: ${to.query}) for active integration: ${this.integrationHeader}`);
          };
      }
    },
    getPostUnSubAction() {
      switch (this.integrationHeader) {
        default:
          return () => {
            // eslint-disable-next-line
            console.log(`No action needed for active integration: ${this.integrationHeader}`);
          };
      }
    },

    // ------------- integration helper methods -----------------------------------
    getIntegrationByName(name = this.integrationHeader) {
      if (!name) {
        return '';
      }
      const integrationKey = Object.keys(this.availableIntegrations).find(key => this.availableIntegrations[key].name === name);
      return { key: integrationKey, value: this.availableIntegrations[integrationKey] };
    },
    registerCheck(msisdn) {
      return this.getUserExistsInCore(msisdn).then((response) => {
        if (response.data) {
          this.getUserIsRegistered(msisdn).then((res) => {
            if (res.data) {
              this.$router.push('login');
            } else {
              this.$router.push('register3');
            }
          });
        } else {
          this.$router.push('/');
        }
      });
    },
    setActiveIntegrationInfo(info) {
      this.updateIntegrationInfo({ name: this.getIntegrationByName().key, value: info });
    },
    toggleSelectOperatorModal(value) {
      this.setShowSelectOperatorModal({ value });
    },
    getSelectOperatorModalChoice() {
      return this.showSelectOperatorModal;
    },
    getSmsModal() {
      return this.showCustomSmsModal;
    },
    hasExternalRedirection() {
      return this.getIntegrationByName() && this.getIntegrationByName().value.hasExternalRedirection;
    },
    hidePage() {
      return this.getIntegrationByName() && this.getIntegrationByName().value.hidePage;
    },
  },
  computed: {
    ...mapState('common', [
      'oneTimeSubscriptionBundleId',
      'defaultDailySubButtonEnabled',
      'fbReferral',
      'banner',
      'integrationHeader',
      'multiOperatorInfo',
      'availableIntegrations',
      'showSelectOperatorModal',
      'showCustomSmsModal',
      'userDetails',
    ]),
    ...mapGetters('common', [
      'getClickId',
      'getRefUrl',
      'getCampaignId',
      'getPublisherId',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
  },
};

export default IntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integration.js